export default __webpack_public_path__ + "static/media/Brain-06.1e16be60.svg";